import { render } from "./EditDescriptionComponent.vue?vue&type=template&id=4288b184"
import script from "./EditDescriptionComponent.vue?vue&type=script&lang=js"
export * from "./EditDescriptionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__